import { useState, useEffect } from 'react';
import styles from './Equipe.module.css';
import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
import MobileMenu from '../../../shared/components/MobileMenu';
import HeaderAdmin from '../components/HeaderAdmin';
import CadastrarFuncionarioPopUp from '../../../shared/components/CadastrarFuncionarioPopUp';
import { MdEdit, MdMoreVert, MdClose, MdPersonAdd, MdGroup, MdCheckCircle, MdEmail, MdPhone } from 'react-icons/md';

function Equipe() {
  const [funcionarios, setFuncionarios] = useState([]);
  const [mostrarCadastro, setMostrarCadastro] = useState(false);
  const [menuAberto, setMenuAberto] = useState(null);
  const [funcionarioEditando, setFuncionarioEditando] = useState(null);

  const buscarFuncionarios = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const estabelecimento_id = localStorage.getItem("estabelecimento_id");

      if (!estabelecimento_id) {
        console.error("ID do estabelecimento não encontrado");
        return;
      }

      const response = await fetch(`${API_URL}/funcionarios/${estabelecimento_id}`);
      if (!response.ok) throw new Error("Erro ao buscar funcionários");
      const data = await response.json();

      setFuncionarios(data);
    } catch (error) {
      console.log("Erro ao buscar funcionários:", error);
    }
  };

  useEffect(() => {
    buscarFuncionarios();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuAberto && !e.target.closest(`.${styles.menuWrapper}`)) {
        setMenuAberto(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuAberto]);

  const getInitials = (nome) => {
    const names = nome.split(' ');
    if (names.length >= 2) {
      return names[0][0] + names[1][0];
    }
    return nome.substring(0, 2);
  };

  const contarAtivos = () => {
    return funcionarios.filter(f => f.ativo !== 0).length;
  };

  const getStatusLabel = (funcionario) => {
    if (funcionario.ativo === 0) return 'INATIVO';
    return 'ATIVO';
  };

  const handleDesativar = async (id_funcionario) => {
    if (!window.confirm('Tem certeza que deseja desativar este funcionário?')) {
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_URL}/funcionarios/${id_funcionario}/desativar`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ ativo: 0 })
      });

      if (response.ok) {
        alert('Funcionário desativado com sucesso!');
        buscarFuncionarios();
        setMenuAberto(null);
      } else {
        alert('Erro ao desativar funcionário.');
      }
    } catch (error) {
      console.error('Erro ao desativar funcionário:', error);
      alert('Erro ao desativar funcionário.');
    }
  };

  const handleEditar = (funcionario) => {
    setFuncionarioEditando(funcionario);
    setMenuAberto(null);
  };

  return (
    <div className={styles.wrapperDashboard}>
      <MobileMenu />
      <SideBarGestaoAdmin />

      <div className={styles.containerDashboard}>
        <HeaderAdmin />
        <div className={styles.contentDashboard}>
          <div className={styles.mainColumn}>
            <div className={styles.pageHeader}>
  
              <button className={styles.btnAdicionarDesktop} onClick={() => setMostrarCadastro(true)}>
                <MdPersonAdd />
                Adicionar Membro
              </button>
            </div>

            
          

            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Membros</h2>
            </div>

            {funcionarios.length === 0 ? (
              <p className={styles.msg}>Nenhum funcionário cadastrado.</p>
            ) : (
              <div className={styles.membrosGrid}>
                {funcionarios.map((funcionario) => (
                  <div key={funcionario.id_funcionario} className={styles.membroCard}>
                    <div className={styles.cardTopRow}>
                      <span className={`${styles.statusBadge} ${funcionario.ativo !== 0 ? styles.statusAtivo : styles.statusInativo}`}>
                        {getStatusLabel(funcionario)}
                      </span>
                      <div className={styles.menuWrapper}>
                        <button
                          className={styles.btnMenu}
                          onClick={() => setMenuAberto(menuAberto === funcionario.id_funcionario ? null : funcionario.id_funcionario)}
                        >
                          <MdMoreVert />
                        </button>
                        {menuAberto === funcionario.id_funcionario && (
                          <div className={styles.menuDropdown}>
                            <button
                              className={styles.menuItem}
                              onClick={() => handleEditar(funcionario)}
                            >
                              <MdEdit />
                              Editar
                            </button>
                            <button
                              className={`${styles.menuItem} ${styles.menuItemDelete}`}
                              onClick={() => handleDesativar(funcionario.id_funcionario)}
                            >
                              <MdClose />
                              Desativar
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.avatar}>
                      {getInitials(funcionario.nome).toUpperCase()}
                    </div>

                    <span className={styles.membroNome}>{funcionario.nome}</span>
                    <span className={styles.membroCargo}>
                      {funcionario.tipo_usuario || 'Atendente'}
                    </span>

                    {(funcionario.email || funcionario.telefone) && (
                      <div className={styles.membroContatos}>
                        {funcionario.email && (
                          <span className={styles.membroContato}>
                            <MdEmail />
                            {funcionario.email}
                          </span>
                        )}
                        {funcionario.telefone && (
                          <span className={styles.membroContato}>
                            <MdPhone />
                            {funcionario.telefone}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* FAB - Adicionar Membro */}
      <button className={styles.fab} onClick={() => setMostrarCadastro(true)}>
        <MdPersonAdd />
      </button>

      {/* Modal de Edição */}
      {funcionarioEditando && (
        <div className={styles.modalOverlay} onClick={() => setFuncionarioEditando(null)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.closeButton}
              onClick={() => setFuncionarioEditando(null)}
            >
              ×
            </button>
            <ModalEditarFuncionario
              funcionario={funcionarioEditando}
              onClose={() => setFuncionarioEditando(null)}
              onEdicaoSucesso={buscarFuncionarios}
            />
          </div>
        </div>
      )}

      {/* Modal de Cadastro */}
      {mostrarCadastro && (
        <div className={styles.modalOverlay} onClick={() => setMostrarCadastro(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.closeButton}
              onClick={() => setMostrarCadastro(false)}
            >
              ×
            </button>
            <CadastrarFuncionarioPopUp
              onClose={() => setMostrarCadastro(false)}
              onCadastroSucesso={buscarFuncionarios}
            />
          </div>
        </div>
      )}
    </div>
  );
}

// Componente de Modal de Edição
function ModalEditarFuncionario({ funcionario, onClose, onEdicaoSucesso }) {
  const [nome, setNome] = useState(funcionario.nome);
  const [email, setEmail] = useState(funcionario.email);
  const [telefone, setTelefone] = useState(funcionario.telefone);

  const handleEditar = async (e) => {
    e.preventDefault();

    if (!nome || !email || !telefone) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_URL}/funcionario/${funcionario.id_funcionario}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          nome,
          email,
          telefone
        })
      });

      if (response.ok) {
        alert('Funcionário atualizado com sucesso!');
        onEdicaoSucesso();
        onClose();
      } else {
        alert('Erro ao atualizar funcionário.');
      }
    } catch (error) {
      console.error('Erro ao atualizar funcionário:', error);
      alert('Erro ao atualizar funcionário.');
    }
  };

  return (
    <div className={styles.containerCadastro}>
      <div className={styles.headerCadastro}>
        <h2>Editar Membro da Equipe</h2>
        <p className={styles.subtitulo}>Atualize os dados do membro da equipe</p>
      </div>

      <form className={styles.formCadastro} onSubmit={handleEditar}>
        <div className={styles.inputGroup}>
          <label>Nome Completo</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Digite o nome completo"
            className={styles.input}
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Digite o email"
            className={styles.input}
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Telefone</label>
          <input
            type="text"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            placeholder="(00) 00000-0000"
            className={styles.input}
          />
        </div>

        <button className={styles.btn} type="submit">
          Salvar Alterações
        </button>
      </form>
    </div>
  );
}

export default Equipe;
